import { render, staticRenderFns } from "./UpgradePlans.vue?vue&type=template&id=bf7dac5e&scoped=true&"
import script from "./UpgradePlans.vue?vue&type=script&lang=ts&"
export * from "./UpgradePlans.vue?vue&type=script&lang=ts&"
import style0 from "./UpgradePlans.vue?vue&type=style&index=0&id=bf7dac5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7dac5e",
  null
  
)

export default component.exports